import React from 'react';
import './WorkerCard.css';

const WorkerCard = ({ name, profession, rating, completedJobs, hourlyRate, image, skills, verified, distance, onBookNow }) => {
    const handleBookNow = () => {
        if (onBookNow) {
            onBookNow({ name, profession, hourlyRate });
        } else {
            alert(`Booking ${name} for ${profession} services. We will contact you shortly!`);
        }
    };

    const handleViewProfile = () => {
        alert(`Viewing profile for ${name}\n\nProfession: ${profession}\nRating: ${rating}\nCompleted Jobs: ${completedJobs}\nHourly Rate: ₹${hourlyRate}\n\nFull profile feature coming soon!`);
    };

    const initials = name
        ? name.trim().split(/\s+/).map(n => n[0]).slice(0, 2).join('').toUpperCase()
        : '?';

    return (
        <div className="worker-card">
            {verified && <div className="verified-badge">✓ Verified</div>}
            {distance && <div className="distance-badge">⊙ {distance}</div>}

            <div className="worker-image">
                {image || initials}
            </div>

            <h3 className="worker-name">{name}</h3>
            <p className="worker-profession">{profession}</p>

            <div className="worker-stats">
                <div className="stat-item stat-rating">
                    <span className="stat-value">★ {rating}</span>
                    <span className="stat-label">Rating</span>
                </div>
                <div className="stat-item">
                    <span className="stat-value">{completedJobs}</span>
                    <span className="stat-label">Jobs done</span>
                </div>
                <div className="stat-item">
                    <span className="stat-value">₹{hourlyRate}</span>
                    <span className="stat-label">per hour</span>
                </div>
            </div>

            {skills && (
                <div className="worker-skills">
                    {(Array.isArray(skills) ? skills : skills.split(',').map(s => s.trim()).filter(Boolean)).slice(0, 3).map((skill, index) => (
                        <span key={index} className="skill-badge">{skill}</span>
                    ))}
                </div>
            )}

            <div className="worker-actions">
                <button className="btn btn-primary" onClick={handleBookNow}>Book Now</button>
                <button className="btn btn-secondary" onClick={handleViewProfile}>View Profile</button>
            </div>
        </div>
    );
};

export default WorkerCard;
